(function () {

    angular
        .module('smartertoolsApp')
        .factory('cacheControl', ['CacheFactory', cacheControl]);

    function cacheControl(cacheFactory) {
        return {
            clearAllCaches: clearAllCaches,
            getCache: getCache
        };

        // -----------------------------------------------

        function clearAllCaches() {
            cacheFactory.destroyAll();
        }

        function getCache(name) {
            const cf = cacheFactory.get(name);
            if (cf) return cf;

            cacheFactory.createCache(name,
                {
                    deleteOnExpire: 'aggressive',
                    maxAge: 1 * 60 * 1000,
                    storageMode: 'sessionStorage',
                    storagePrefix: 'c.'
                });
            return cacheFactory.get(name);
        }
    }

})();